import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/NpmErrors.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const BlogNpmErrors = () => {
  const questionId = "1"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckNpmErrorSize = useRef(false);

  // Fetching images
  const NpmSolutionImages = require.context(
    "../../../assets/images/Blogs/ProblemSolving/npm-errors", // Path to the directory
    false, // Do not include subdirectories (set to true if you want to include them)
    /\.(png|PNG|jpg|jpeg|webp|svg|avif)$/ // Regular expression to match file types
  );
  const NpmImgStep1 = NpmSolutionImages("./npmstepno1.avif"); // Dynamically load the image
  const NpmImgStep2 = NpmSolutionImages("./npmstepno2.avif"); // Dynamically load the image
  const NpmImgStep3 = NpmSolutionImages("./npmstepno3.avif"); // Dynamically load the image
  const NpmImgStep4 = NpmSolutionImages("./npmstepno4.avif"); // Dynamically load the image
  const NpmImgStep5 = NpmSolutionImages("./npmstepno5.avif"); // Dynamically load the image
  const NpmImgStep6 = NpmSolutionImages("./npmstepno6.avif"); // Dynamically load the image

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } = CheckNpmErrorSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://youtu.be/vn97BdYx2K8?si=dREgydiiQhVOloo0",
    RTL2: "https://youtu.be/bxvybxYFq2o?si=MBvQKQwIKJsNnt-d",
    RTL3: "https://youtu.be/hQSoKelw3P8?si=d6ti40KnFHabzLkg",
    RTL4: "https://youtu.be/ES5fxuO5mQw?si=oki2xoPvcvcyIqaK",
    RTL5: "https://stackoverflow.com/questions/20259492/npm-not-working-after-clearing-cache",
    RTL6: "https://stackoverflow.com/questions/42147243/how-does-npm-handle-version-conflicts",
    RTC1: "Npm installation issues",
    RTC2: "Npm permission errors",
    RTC3: "Npm module not found",
    RTC4: "Npm network failures",
    RTC5: "Npm cache problems",
    RTC6: "Npm version conflicts",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Npm is Not Recognized in This Path – Fix It Easily 🚀</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Fix the 'npm is not recognized' error with simple steps. Learn why this happens and how to resolve it quickly."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="npm error, npm not recognized, fix npm path, node.js setup, command prompt error"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Npm is Not Recognized in This Path – Fix It Easily 🚀"
        />
        <meta
          property="og:description"
          content="Fix the 'npm is not recognized' error with simple steps. Learn why this happens and how to resolve it quickly."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/npmerrors"
        />
        {/* <meta property="og:image" content="/images/NpmErrors/npmstepno1.png" /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Npm is Not Recognized in This Path – Fix It Easily 🚀"
        />
        <meta
          name="twitter:description"
          content="Fix the 'npm is not recognized' error with simple steps. Learn why this happens and how to resolve it quickly."
        />
        {/* <meta name="twitter:image" content="/images/NpmErrors/npmstepno1.png" /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/npmerrors"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div className={Styles.BlogSidebarNpmErrorsContainer}>
        <Sidebar {...SidebarProps} />
        <div ref={CheckNpmErrorSize} className={Styles.BlogNpmErrorsContainer}>
          <section className={Styles.BlogNpmErrorsSection1Container}>
            <div
              className={
                Styles.BlogNpmErrorsSection1QuestionLikesViewsContainer
              }
            >
              <h4>Problem</h4>
              <h1>
                Npm is not recognized in this path. Please try a different path.
                As you guys know, I am very upset. How can I fix it? Please
                anyone tell me.
              </h1>
              <div className={Styles.BlogNpmErrorsSection1LikesViewsContainer}>
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.BlogNpmErrorsSection2Container}>
            <div className={Styles.BlogNpmErrorsSection2AnswerContainer}>
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.BlogNpmErrorsSection2AnswerVideo1}
                src="https://www.youtube.com/embed/n6BzliZA_R0?si=G1tqmyBd8P7mO9S9"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step No. 2 ....</h3>
              <p>
                1. The npm path is not present in the system environment
                variables. For example, if Node.js does not automatically add
                the npm path to the system environment variables, it can cause
                errors.
              </p>
              <p>2. To resolve this issue, follow these steps:</p>
              <div
                className={Styles.BlogNpmErrorsSection2AnswerImagesContainer}
              >
                <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                  <p>
                    👉🏻 In Windows, search for 'Environment Variables' and open
                    it.
                  </p>
                  <img src={NpmImgStep1} alt="loding step 1" />
                </div>
                <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                  <p>👉🏻 Navigate to "Environment Variables".</p>
                  <img src={NpmImgStep2} alt="loding step 2" />
                </div>
                <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                  <p>
                    👉🏻 In the System Variables section, select "Path" and click
                    on "Edit".
                  </p>
                  <img src={NpmImgStep3} alt="loding step 3" />
                </div>
                <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                  <p>👉🏻 Click on "New".</p>
                  <img src={NpmImgStep4} alt="loding step 4" />
                </div>
                <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                  <p>👉🏻 Add your npm file path to the list and click "OK".</p>
                  <img src={NpmImgStep5} alt="loding step 5" />
                </div>
              </div>
              <p>
                If these steps resolved your issue, you can skip the remaining
                steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step No. 3 ....</h3>
              <p>
                In some cases, the environment variables may contain multiple
                paths for npm, which can cause npm to be unable to determine the
                correct path. To resolve this issue, remove any incorrect or
                duplicate paths from the environment variables, and your problem
                should be fixed.
              </p>
              <div className={Styles.BlogNpmErrorsSection2AnswerImgContainer}>
                <p>👉🏻 Delete duplicate paths to resolve the issue.</p>
                <img src={NpmImgStep6} alt="loding step 6" />
              </div>

              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BlogNpmErrors;
